import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    callout: {
      content:
        'All feature flags are not yet migrated for this page, please contact the dedicated project team if you want to activate a feature.',
      title:
        'This page allows you to activate or deactivate features under development.',
    },
    features: {
      enableCashFlowManagement: {
        subtitle: 'Enable a dashboard to see spendings and earnings easily',
        title: 'Cash flow management',
      },
      enableCashFlowMultiWallet: {
        subtitle:
          'Allow the user to select a sub-wallet to display in the dasboard/treasury pages',
        title: 'Cash flow multi-wallet',
      },
      enableCompanyAddressSelfChange: {
        subtitle: 'Not migrated yet',
        title: 'enableCompanyAddressSelfChange',
      },
      enableEnhancedBirthCityInput: {
        subtitle: 'Not migrated yet',
        title: 'enableEnhancedBirthCityInput',
      },
      enableInternationalTransfer: {
        subtitle: 'Enable international transfer',
        title: 'International transfer',
      },
      enableInvoicingTradeNameOption: {
        subtitle:
          'Allow the user to choose to display the trade name on invoices',
        title: 'Display trade name in invoicing',
      },
      enableMandateeOnboarding: {
        subtitle: 'Not migrated yet',
        title: 'enableMandateeOnboarding',
      },
      enableMultipleTransactionDocs: {
        subtitle:
          'Enable linking multiple invoices and receipts to a transaction',
        title: 'Multiple transaction documents',
      },
      enableNewAccountingExport: {
        subtitle: 'Revamped accounting export with more powerful capabilities',
        title: 'New accounting export',
      },
      enableNewCardFlowManagement: {
        subtitle: 'Enable the new card management pages',
        title: 'Card flow management',
      },
      enableNewInsurance: {
        subtitle: 'Enable the new insurance pages',
        title: 'Insurance V3',
      },
      enableNewLandbotFlow: {
        subtitle: 'New landbot flow',
        title: 'enableNewLandbotFlow',
      },
      enableNewNav: {
        subtitle: 'Enable the new navigation branding 🚧',
        title: 'enableNewNav',
      },
      enableNewPsp: {
        subtitle:
          'Allow the user to create a Stripe account for the company and check its onboarding status (on /psp route)',
        title: 'enableNewPsp',
      },
      enableNewVirtualCardOrder: {
        subtitle: 'Enables the new virtual card ordering flow',
        title: 'Virtual card order',
      },
      enableSasuActivities: {
        subtitle:
          'Internalisation of the activity choice stage in SASU creation',
        title: 'Choosing SASU activities',
      },
      enableSiretWall: {
        subtitle: 'Not migrated yet',
        title: 'enableSiretWall',
      },
      enableStandardOnboardingBeneficiaryFlowRedesign: {
        subtitle:
          'Redesign beneficiary list flow to try boost conversion, leaving cap dep process untouched',
        title:
          'Multi KYC - Beneficiary list redesign for standard onboarding process',
      },
      enableSwiftTransfer: {
        subtitle: 'Not migrated yet',
        title: 'enableSwiftTransfer',
      },
    },
    qaTitle: '🧪 In QA',
    releasedTitle: '🚀 Available in production',
    reset: 'Reset',
    title: 'Feature flag',
    wipTitle: '🚧 Work in progress',
  },
  fr: {
    callout: {
      content:
        "L'ensemble des feature flag ne sont pas encore migrés pour l'utilisation de cette page, rapprochez vous de l'équipe projet dédiée si vous souhaitez activer une fonctionnalité.",
      title:
        "Cette page permet d'activer ou de désactiver des fonctionnalités en cours de développement.",
    },
    features: {
      enableCashFlowManagement: {
        subtitle:
          'Active un nouveau dashboard pour suivre ses gains et ses dépenses',
        title: 'Cash flow management',
      },
      enableCashFlowMultiWallet: {
        subtitle:
          "Permettre à l'utilisateur de choisir un wallet à afficher dans les pages dashboard/trésoreire",
        title: 'Cash flow multi-wallet',
      },
      enableCompanyAddressSelfChange: {
        subtitle: 'Pas encore migré',
        title: 'enableCompanyAddressSelfChange',
      },
      enableEnhancedBirthCityInput: {
        subtitle: 'Pas encore migré',
        title: 'enableEnhancedBirthCityInput',
      },
      enableInternationalTransfer: {
        subtitle: 'Permet à l’utilisateur de faire un virement international',
        title: 'Transfert international',
      },
      enableInvoicingTradeNameOption: {
        subtitle:
          'Permet à l’utilisateur de choisir s’il veut afficher le nom commercial sur ses factures',
        title: 'Afficher le nom commercial dans la facturation',
      },
      enableMandateeOnboarding: {
        subtitle: 'Pas encore migré',
        title: 'enableMandateeOnboarding',
      },
      enableMultipleTransactionDocs: {
        subtitle:
          'Possibilité de lier plusieurs factures et reçus à une transaction',
        title: 'Documents de transaction multiples',
      },
      enableNewAccountingExport: {
        subtitle:
          'Exportation comptable remaniée avec des fonctionnalités plus puissantes',
        title: 'Nouvelle exportation comptable',
      },
      enableNewCardFlowManagement: {
        subtitle: 'Active les nouvelles pages de gestion de carte',
        title: 'Card flow management',
      },
      enableNewInsurance: {
        subtitle: 'Active les nouvelles pages d’assurance',
        title: 'Assurance V3',
      },
      enableNewLandbotFlow: {
        subtitle: 'Nouveau flow landbot',
        title: 'enableNewLandbotFlow',
      },
      enableNewNav: {
        subtitle: 'Active le nouveau branding de la nav 🚧',
        title: 'enableNewNav',
      },
      enableNewPsp: {
        subtitle:
          'Permet à l’utilisateur de créer un compte Stripe pour l’entreprise et vérifier son statut d’onboarding (sur la route /psp)',
        title: 'enableNewPsp',
      },
      enableNewVirtualCardOrder: {
        subtitle: 'Active le nouveau flow de commande de carte virtuelle',
        title: 'Commande de carte virtuelle',
      },
      enableSasuActivities: {
        subtitle:
          'Internalisation de l’étape de choix d’activité dans la création de SASU',
        title: 'Choix d’activités SASU',
      },
      enableSiretWall: {
        subtitle: 'Pas encore migré',
        title: 'enableSiretWall',
      },
      enableStandardOnboardingBeneficiaryFlowRedesign: {
        subtitle:
          'Refonte de la liste des bénéficiaires pour tenter d’augmenter le taux de conversion, sans toucher à la procédure de dépôt de capital',
        title:
          'Multi KYC - Redesign de la liste des bénéficiaires pour le processus de souscription standard',
      },
      enableSwiftTransfer: {
        subtitle: 'Pas encore migré',
        title: 'enableSwiftTransfer',
      },
    },
    qaTitle: '🧪 En QA',
    releasedTitle: '🚀 Disponible en production',
    reset: 'Réinitialiser',
    title: 'Feature flag',
    wipTitle: '🚧 En cours de développement',
  },
} as const);

export default locales;
